import { FC } from "react";
import ReactModal from "react-modal";
// import { HandledEvents } from "react-swipeable/es/types";
import clsx from "clsx";
import { ModalProps } from "./types";
import styles from "./styles.scss";
// import { useSwipeDownGesture } from "./use-swipe-down-gesture";

export const Modal: FC<ModalProps> = ({
  children,
  className,
  overlayClassName,
  // onRequestClose,
  // isSwipeDisabled = false,
  ...props
}) => {
  // const { ref, modalStyles } = useSwipeDownGesture(
  //   onRequestClose as unknown as (event: HandledEvents) => void,
  //   isSwipeDisabled,
  // );

  return (
    <ReactModal
      {...props}
      // contentRef={ref}
      overlayClassName={clsx(styles.overlay, overlayClassName)}
      className={clsx(styles.modalContainer, className)}
      style={{
        overlay: {
          ...props.style?.overlay,
          // ...modalStyles?.overlay,
        },
        content: {
          ...props.style?.content,
          // ...modalStyles?.content,
        },
      }}
      // onRequestClose={onRequestClose}
    >
      {children}
    </ReactModal>
  );
};
